// English + Arabic. The English text is the key: t("Send") → "إرسال" in Arabic. Missing Arabic falls back to English
// (tests/unit/i18n.test.ts lists any t("…") without an Arabic entry). {name} placeholders are filled from vars.
import { AR } from "./i18n-ar.ts";

export type Lang = "en" | "ar";
const saved = (() => { try { return localStorage.getItem("lang"); } catch { return null; } })();
let lang: Lang = saved === "ar" || saved === "en" ? saved : (typeof navigator !== "undefined" && /^ar\b/i.test(navigator.language) ? "ar" : "en");

export const getLang = () => lang;
export function t(s: string, vars?: Record<string, string | number>): string {
  const out = lang === "ar" ? AR[s] ?? s : s;
  return vars ? out.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? "")) : out;
}
export function applyLang() {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
}
export function setLang(l: Lang) {
  lang = l;
  try { localStorage.setItem("lang", l); } catch { /* private mode */ }
  applyLang();
}
